import { lazy } from 'react';

// Lazy-loaded route page components. Centralized so App.js only
// contains routing/auth logic.

export const PricingPage = lazy(() => import('./pages/PricingPage'));
export const QuickSealDemo = lazy(() => import('./pages/QuickSealDemo'));
export const QuickSealReceipt = lazy(() => import('./pages/QuickSealReceipt'));
export const MySeals = lazy(() => import('./pages/MySeals'));
export const Dashboard = lazy(() => import('./pages/Dashboard'));
export const NotaryOnboarding = lazy(() => import('./pages/NotaryOnboarding'));
export const NotaryDashboard = lazy(() => import('./pages/NotaryDashboard'));
export const RequestNotarization = lazy(() => import('./pages/RequestNotarization'));
export const VerifyDocument = lazy(() => import('./pages/VerifyDocument'));
export const CheckoutPage = lazy(() => import('./pages/CheckoutPage'));
export const CryptoCheckout = lazy(() => import('./pages/CryptoCheckout'));
export const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'));
export const PaymentCancel = lazy(() => import('./pages/PaymentCancel'));
export const NotaryVideoSession = lazy(() => import('./pages/NotaryVideoSession'));
export const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
export const AdminIntegrations = lazy(() => import('./pages/AdminIntegrations'));
export const LivingIdentity = lazy(() => import('./pages/LivingIdentity'));
export const PublicChallenge = lazy(() => import('./pages/PublicChallenge'));
export const PublicVerify = lazy(() => import('./pages/PublicVerify'));
export const NotaryDirectory = lazy(() => import('./pages/NotaryDirectory'));
export const NotaryProfile = lazy(() => import('./pages/NotaryProfile'));
export const TrustLayerLanding = lazy(() => import('./pages/TrustLayerLanding'));
export const TrustGraph = lazy(() => import('./pages/TrustGraph'));
export const AdminTrustLayer = lazy(() => import('./pages/AdminTrustLayer'));
export const AssetVault = lazy(() => import('./pages/AssetVault'));
export const HandoffAccept = lazy(() => import('./pages/HandoffAccept'));
export const TrustHub = lazy(() => import('./pages/TrustHub'));
export const FloridaLanding = lazy(() => import('./pages/FloridaLanding'));
export const FloridaNotaryOnboard = lazy(() => import('./pages/FloridaNotaryOnboard'));
export const KBATest = lazy(() => import('./pages/KBATest'));
export const FloridaWitnessAccept = lazy(() => import('./pages/FloridaWitnessAccept'));
export const FloridaCeremonyReadiness = lazy(() => import('./pages/FloridaCeremonyReadiness'));
export const NotaryFLJournal = lazy(() => import('./pages/NotaryFLJournal'));
export const AdminFLCompliance = lazy(() => import('./pages/AdminFLCompliance'));
export const AdminSubpoena = lazy(() => import('./pages/AdminSubpoena'));
export const FLNotaryRecruitment = lazy(() => import('./pages/FLNotaryRecruitment'));
export const NotariesWanted = lazy(() => import('./pages/NotariesWanted'));
export const AdminFLRecruitment = lazy(() => import('./pages/AdminFLRecruitment'));
export const AdminFLRonsp = lazy(() => import('./pages/AdminFLRonsp'));
export const FieldScanner = lazy(() => import('./pages/FieldScanner'));
export const PublicScannerDemo = lazy(() => import('./pages/PublicScannerDemo'));
export const EmbedCeremony = lazy(() => import('./pages/EmbedCeremony'));
export const DeveloperSDK = lazy(() => import('./pages/DeveloperSDK'));
export const SDKKeys = lazy(() => import('./pages/SDKKeys'));
export const MyDocuments = lazy(() => import('./pages/MyDocuments'));
export const StateComparison = lazy(() => import('./pages/StateComparison'));
export const StateDetail = lazy(() => import('./pages/StateDetail'));
export const ComplianceMatrix = lazy(() => import('./pages/ComplianceMatrix'));
export const VerifyWallet = lazy(() => import('./pages/VerifyWallet'));
export const SmartJournal = lazy(() => import('./pages/SmartJournal'));
export const PartnerProgram = lazy(() => import('./pages/PartnerProgram'));
export const PartnerKit = lazy(() => import('./pages/PartnerKit'));
export const AdminPartners = lazy(() => import('./pages/AdminPartners'));
export const Academy = lazy(() => import('./pages/Academy'));
export const AcademyModule = lazy(() => import('./pages/AcademyModule'));
export const AcademyExam = lazy(() => import('./pages/AcademyExam'));
export const AdminAcademy = lazy(() => import('./pages/AdminAcademy'));
export const CompliancePublicSnapshot = lazy(() => import('./pages/CompliancePublicSnapshot'));
export const UserGuide = lazy(() => import('./pages/UserGuide'));
export const Marketplace = lazy(() => import('./pages/Marketplace'));
export const AdminCeremonyAnalytics = lazy(() => import('./pages/AdminCeremonyAnalytics'));
export const TrustBadges = lazy(() => import('./pages/TrustBadges'));
export const SovereignID = lazy(() => import('./pages/SovereignID'));
export const SovereignVerify = lazy(() => import('./pages/SovereignVerify'));
export const TrustBadgeLanding = lazy(() => import('./pages/TrustBadgeLanding'));
export const TransactionsPage = lazy(() => import('./pages/TransactionsPage'));
export const TransactionRoom = lazy(() => import('./pages/TransactionRoom'));
export const NotarizationCertificate = lazy(() => import('./pages/NotarizationCertificate'));
export const BlueprintCreator = lazy(() => import('./pages/BlueprintCreator'));
export const SecuritySettings = lazy(() => import('./pages/SecuritySettings'));
export const SubscriptionPage = lazy(() => import('./pages/SubscriptionPage'));
export const SubscriptionSuccess = lazy(() => import('./pages/SubscriptionSuccess'));
export const NotaryJournal = lazy(() => import('./pages/NotaryJournal'));
export const DigitalSeal = lazy(() => import('./pages/DigitalSeal'));
export const CompliancePage = lazy(() => import('./pages/CompliancePage'));
export const DeveloperPage = lazy(() => import('./pages/DeveloperPage'));
export const RONComplianceDashboard = lazy(() => import('./pages/RONComplianceDashboard'));
export const TemplateLibrary = lazy(() => import('./pages/TemplateLibrary'));
export const TemplateWizard = lazy(() => import('./pages/TemplateWizard'));
export const SmartContractsPage = lazy(() => import('./pages/SmartContractsPage'));
export const MyAnchors = lazy(() => import('./pages/MyAnchors'));
export const VerifyAnchor = lazy(() => import('./pages/VerifyAnchor'));
export const CeremonyVaultPage = lazy(() => import('./pages/CeremonyVaultPage'));
export const VerifyCeremonyVideo = lazy(() => import('./pages/VerifyCeremonyVideo'));
export const OrganizationPage = lazy(() => import('./pages/OrganizationPage'));
export const MyDrafts = lazy(() => import('./pages/MyDrafts'));
export const SharedDraftViewer = lazy(() => import('./pages/SharedDraftViewer'));
export const BulkNotarization = lazy(() => import('./pages/BulkNotarization'));
export const NotaryMarketplace = lazy(() => import('./pages/NotaryMarketplace'));
export const WhiteLabelPage = lazy(() => import('./pages/WhiteLabelPage'));
export const BookingCalendar = lazy(() => import('./pages/BookingCalendar'));
export const MyBookings = lazy(() => import('./pages/MyBookings'));
export const ReviewInsights = lazy(() => import('./pages/ReviewInsights'));
export const VerifyEmail = lazy(() => import('./pages/VerifyEmail'));
export const AdminSupportView = lazy(() => import('./pages/AdminSupportView'));
export const AIDocumentGenerator = lazy(() => import('./pages/AIDocumentGenerator'));
export const TemplateMarketplace = lazy(() => import('./pages/TemplateMarketplace'));
export const AIDocumentSummarizer = lazy(() => import('./pages/AIDocumentSummarizer'));
export const VideoWitness = lazy(() => import('./pages/VideoWitness'));
export const DocumentRemediation = lazy(() => import('./pages/DocumentRemediation'));
export const BiometricPassportPage = lazy(() => import('./pages/BiometricPassportPage'));
export const AIConductorPage = lazy(() => import('./pages/AIConductorPage'));
export const EvidencePackagePage = lazy(() => import('./pages/EvidencePackagePage'));
export const TransactionTimeline = lazy(() => import('./pages/TransactionTimeline'));
export const RemindersPage = lazy(() => import('./pages/RemindersPage'));
export const ApprovalsPage = lazy(() => import('./pages/ApprovalsPage'));
export const DocComparePage = lazy(() => import('./pages/DocComparePage'));
export const BrandingPage = lazy(() => import('./pages/BrandingPage'));
export const SSOLoginPage = lazy(() => import('./pages/SSOLoginPage'));
export const Auth0Callback = lazy(() => import('./pages/Auth0Callback'));
export const OktaCallback = lazy(() => import('./pages/OktaCallback'));
export const OnboardingPage = lazy(() => import('./pages/OnboardingPage'));
export const InvestorDeck = lazy(() => import('./pages/InvestorDeck'));
export const CeremonyDashboard = lazy(() => import('./pages/CeremonyDashboard'));
export const VerifyCertificate = lazy(() => import('./pages/VerifyCertificate'));
export const EscrowDashboard = lazy(() => import('./pages/EscrowDashboard'));
export const ANANDashboard = lazy(() => import('./pages/ANANDashboard'));
export const FraudIntelligencePage = lazy(() => import('./pages/FraudIntelligencePage'));
export const AIIntelligenceHub = lazy(() => import('./pages/AIIntelligenceHub'));
export const PublicAuditTrail = lazy(() => import('./pages/PublicAuditTrail'));
export const CeremonyReplay = lazy(() => import('./pages/CeremonyReplay'));
export const MultiSignature = lazy(() => import('./pages/MultiSignature'));
export const CertificateExpiration = lazy(() => import('./pages/CertificateExpiration'));
export const TokenizedEscrow = lazy(() => import('./pages/TokenizedEscrow'));
export const PCVDashboard = lazy(() => import('./pages/PCVDashboard'));
export const PCVPublicVerify = lazy(() => import('./pages/PCVPublicVerify'));
export const NotaryIdCard = lazy(() => import('./pages/NotaryIdCard'));
export const IdCardVerify = lazy(() => import('./pages/IdCardVerify'));
export const MagicLinkVerify = lazy(() => import('./pages/MagicLinkVerify'));
export const SignerPrep = lazy(() => import('./pages/SignerPrep'));
export const PCVMarketing = lazy(() => import('./pages/PCVMarketing'));
export const BatchCertificates = lazy(() => import('./pages/BatchCertificates'));
export const ACNDashboard = lazy(() => import('./pages/ACNDashboard'));
export const ACNPublicVerify = lazy(() => import('./pages/ACNPublicVerify'));
export const BetaProgram = lazy(() => import('./pages/BetaProgram'));
export const NotaryGuard = lazy(() => import('./pages/NotaryGuard'));
export const NotaryGuardVerify = lazy(() => import('./pages/NotaryGuardVerify'));
export const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
export const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage'));
export const TrainingManual = lazy(() => import('./pages/TrainingManual'));
export const AdminDataCleanup = lazy(() => import('./pages/AdminDataCleanup'));
export const FLRegistryLookup = lazy(() => import('./pages/FLRegistryLookup'));
export const PDFSplitter = lazy(() => import('./pages/PDFSplitter'));
export const NotFound = lazy(() => import('./pages/NotFound'));
export const HederaAnalytics = lazy(() => import('./pages/HederaAnalytics'));
export const AdminCampaignLinks = lazy(() => import('./pages/AdminCampaignLinks'));
export const FraudShield = lazy(() => import('./pages/FraudShield'));
export const LitigationPackets = lazy(() => import('./pages/LitigationPackets'));
export const ContractorLanding = lazy(() => import('./pages/ContractorLanding'));
export const ContractorApp = lazy(() => import('./pages/ContractorApp'));
export const Apostille = lazy(() => import('./pages/Apostille'));
export const EscrowClientView = lazy(() => import('./pages/EscrowClientView'));
export const VerifyEscrowContract = lazy(() => import('./pages/VerifyEscrowContract'));
export const EClosing = lazy(() => import('./pages/EClosing'));
export const EarningsDashboard = lazy(() => import('./pages/EarningsDashboard'));
export const RetentionDashboard = lazy(() => import('./pages/RetentionDashboard'));
export const ConciergeWorkboard = lazy(() => import('./pages/ConciergeWorkboard'));
export const TitleCompany = lazy(() => import('./pages/TitleCompany'));
export const AdminAlertCenter = lazy(() => import('./pages/AdminAlertCenter'));
export const ClosingClientView = lazy(() => import('./pages/ClosingClientView'));
export const ForcePasswordChange = lazy(() => import('./pages/ForcePasswordChange'));
export const Force2FASetup = lazy(() => import('./pages/Force2FASetup'));
export const AdminCompliancePolicies = lazy(() => import('./pages/AdminCompliancePolicies'));
export const AdminCoercionDrill = lazy(() => import('./pages/AdminCoercionDrill'));
export const AdminLockouts = lazy(() => import('./pages/AdminLockouts'));
export const NotaryTagKit = lazy(() => import('./pages/NotaryTagKit'));
export const UnlockAccount = lazy(() => import('./pages/UnlockAccount'));
export const VerifySeal = lazy(() => import('./pages/VerifySeal'));
export const ParcelVerify = lazy(() => import('./pages/ParcelVerify'));
export const DeedJourney = lazy(() => import('./pages/DeedJourney'));
export const CountyFeedRoadmap = lazy(() => import('./pages/CountyFeedRoadmap'));
export const PublicDeedProof = lazy(() => import('./pages/PublicDeedProof'));
export const AdminSmsLog = lazy(() => import('./pages/AdminSmsLog'));
export const RescheduleByLink = lazy(() => import('./pages/RescheduleByLink'));
export const ForInvestors = lazy(() => import('./pages/ForInvestors'));
export const InvestorDemo = lazy(() => import('./pages/InvestorDemo'));
export const Architecture = lazy(() => import('./pages/Architecture'));
export const TrustCenter = lazy(() => import('./pages/TrustCenter'));
export const VesselAircraftClosings = lazy(() => import('./pages/VesselAircraftClosings'));
export const PracticeSession = lazy(() => import('./pages/PracticeSession'));
export const AdminSalesLeads = lazy(() => import('./pages/AdminSalesLeads'));
export const AdminRequests = lazy(() => import('./pages/AdminRequests'));
export const AdminCspReports = lazy(() => import('./pages/AdminCspReports'));
export const LoiManager = lazy(() => import('./pages/LoiManager'));
export const LoiSign = lazy(() => import('./pages/LoiSign'));
export const DealsList = lazy(() => import('./pages/DealsList'));
export const DealRoom = lazy(() => import('./pages/DealRoom'));
export const ChainOfTitle = lazy(() => import('./pages/ChainOfTitle'));
export const DealSign = lazy(() => import('./pages/DealSign'));
export const ClientDealView = lazy(() => import('./pages/ClientDealView'));
